import React from "react";
import styles from "./privacyPolicy.module.css";
function PrivacyPolicy() {
    return (
        <div className={styles.privacyPolicyMainContainer}>
            <>
                <title>Niurix - Privacy Policy</title>
                <meta name="description" content="Niurix - Privacy Policy" />
            </>
            <div className={styles.mainWrapper}>
                <div className={styles.privacySubWrapper}>
                    <div className={styles.headerPart}>
                        <span className={`${styles.effectiveDateTxt} ${styles.fontNormal}`}>Effective Date : February 09, 2026</span>
                    </div>
                    <h1 className={styles.mainText}>Privacy Policy</h1>
                    <br></br>
                    <div>
                        <p className={styles.fontBold}>1. Overview</p>
                        <p className={styles.fontNormal}>
                            Your privacy is important to Niurix. This privacy statement applies to data collected through websites owned and
                            operated by Niurix. This statement describes the information practices for Niurix websites including but not
                            limited to &nbsp;
                            <a className={styles.anchorTag} href="mailto:support@niurix.com">
                                support@niurix.com
                            </a>
                            . This privacy statement describes the information practices for Niurix websites, including what types of
                            information are collected, how Niurix uses this information and for what purposes; with whom information is
                            shared; and how Niurix protects information. It also describes your choices regarding use, access, correction
                            and deletion of your information, among other topics. In addition, this statement addresses personal information
                            collection and use by Niurix in certain offline contexts, such as marketing and customer service and support.
                        </p>
                    </div>
                    <div>
                        <div>
                            <p className={styles.fontBold}>2. What Information Do We Collect?</p>
                            <p className={styles.fontNormal}>
                                Niurix collects data to enable us to make our products available to you, and to provide you with the best
                                experience on our website and with our products. You provide some of this data to us directly, such as when
                                you register to create an account on our website, subscribe to a newsletter, respond to a survey, contact us
                                for support, or contact us as a prospective customer, vendor, supplier, or consultant. We also obtain and
                                process data in the context of making the products available to you.
                            </p>
                            <p className={styles.fontNormal}>
                                You have choices about the data we collect. When you are asked to provide personal data, you may decline.
                                But if you choose not to provide data that is necessary to enable us to make the Niurix products available
                                to you, you may not be able to use all or part of those products.
                            </p>
                            <p className={styles.fontNormal}>
                                The data we collect depends on the context of your interactions with Niurix, the choices you make (including
                                your privacy settings), and the products you use. The data we collect can include the following:
                            </p>
                        </div>
                    </div>
                    <div>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>2.1 Name and contact information -</span> We may collect your first and last
                            name, email address,password, postal address, phone number, company information, and other similar contact data.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>2.2 Device and usage information -</span> We may collect data about your
                            device and how you and your device interact with our product.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>2.3 Use data -</span> We may collect data about the features you use, the
                            products you purchase, and the web pages you visit. This also includes your interactions on our website, and
                            your interactions with us via email.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>2.4 Device, connectivity and configuration data -</span>
                            We may collect data about your device and the network you use to connect to our website or with which you use
                            our products. This may include data about the operating system and other software installed on your device,
                            including product keys. It may also include IP address, browser type, operating system, and referring URLs.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>2.5 Data Quality Assurance -</span>
                            To ensure personal information is accurate, complete, up-to-date, and relevant for its intended purposes, Niurix
                            may implement procedures such as validation checks during collection (e.g., required fields, format
                            verification), periodic reviews of stored data, and automated updates where feasible, wherever needed. We also
                            encourage users to review and update their information via the user dashboard. If inaccuracies are identified,
                            we correct them promptly in accordance with documented internal processes.
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontBold}>3. What Do We Use Your Information For?</p>
                        <p className={styles.fontNormal}>
                            We use the data we collect to operate our business, and to make products available to you. This includes using
                            the data to improve our Niurix product, and to personalize your experiences. We may also use the data to
                            communicate with you, and among other things, inform you about your account, provide security updates, and give
                            you information about the products. We may also use the data to manage your email subscriptions, improve the
                            relevance and security of our website, respond to user enquiries, send you periodic marketing communications
                            about our products, and improve the relevance of our advertising.
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>3.1 Providing and improving our products -</span>
                            We use data to provide and improve the products we offer, and to perform essential business operations. This
                            includes making the products available to you, maintaining and improving the performance of the products,
                            developing new features, conducting research, and providing customer support. Examples of such uses include the
                            following:
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>3.1.1&nbsp;&nbsp;Providing the products -</span> We use data to carry out your
                            transactions with us and to make products available to you. In certain cases, we may use data to automatically
                            tailor your experience based on the data we have about you.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>3.1.2 Technical support - </span> We use data to diagnose product problems,
                            and to provide customer care and support services.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>3.1.3 Improving the products -</span> We use data to improve our website
                            continually and our products, including system administration, system security, and adding new features or
                            capabilities.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>3.1.4 Business operations -</span> We may use your data to help us develop
                            aggregate analysis and business intelligence that enables us to operate, protect, make informed decisions, and
                            report on the performance of our business.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>3.1.5 Improving advertising campaigns -</span>
                            We may use your data to improve our advertising campaigns, primarily to prevent targeting of advertisements
                            which are not relevant to you.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>3.1.6 Sending periodic emails -</span> We may use your data to send you
                            periodic emails. Depending on the marketing preferences you select on your user dashboard, we may send you
                            occasional marketing emails about our products and services, which you can unsubscribe from at any point of time
                            using the link provided in the message.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>3.1.7 Communications -</span> We use data collected to communicate with you,
                            and to personalize our communications with you. For example, we may contact you to inform you when a license is
                            ending, to discuss your account, to let you know when updates are available, to remind you about features of the
                            products that are available for your use, to update you about a support request, or to invite you to participate
                            in a survey. Additionally, you can sign up for email subscriptions and choose whether you want to receive
                            marketing communications from us.
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontBold}>4. How Do We Protect Your Information? </p>
                        <p className={styles.fontNormal}>
                            We implement a variety of security measures to help maintain the safety of your information when you enter,
                            submit, or access your information. We offer the use of a secure server. Sensitive information can only be
                            accessed by those authorized with special access rights to such systems, and who are required to keep the
                            information confidential.
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontBold}>
                            5. How Do We Ensure That Our Processing Systems Remain Confidential, Resilient, and Available?
                        </p>
                        <p className={styles.fontNormal}>
                            We implement a variety of measures to ensure that our processing systems remain confidential, resilient, and
                            available. Specifically, we have implemented processes to help ensure high availability, business continuity,
                            and prompt disaster recovery. We are committed to maintaining strong physical and logical access controls.
                        </p>
                    </div>
                    <div>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>5.1. High availability -</span> We utilize properly-provisioned, redundant
                            servers in case of failure. We take servers out of operation as part of regular maintenance, without impacting
                            availability.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>5.2. Business continuity -</span>We keep periodic encrypted backups of data.
                            While never expected, in the case of production data loss (i.e., primary data stores loss), we will restore
                            organizational data from these backups.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>5.3. Disaster recovery - </span>In the event of a region-wide outage, we will
                            bring up a duplicate environment in a different region. Our operations team has extensive experience performing
                            full region migrations.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>5.4. Physical access controls -</span>
                            Niurix is hosted by one or more secure hosting providers. Our hosting providers' data centres feature layered
                            security models, which may include extensive safeguards such as custom-designed electronic access cards, alarms,
                            vehicle access barriers and biometrics. Unauthorized visitors are not permitted to access the data centres.
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontBold}>6. Do We Disclose any Information to Outside Parties?</p>
                        <p className={styles.fontNormal}>
                            We share your data with your consent, or as necessary to make our product available to you. We also share your
                            data with vendors working on our behalf; when required by law, or to respond to legal process; to protect our
                            customers; to protect lives; to maintain the security and integrity of our products; and to protect our rights
                            or our property. We may disclose your data as part of a corporate transaction such as a corporate sale, merger,
                            reorganization, dissolution, or similar event.
                        </p>
                        {/* <p className={styles.fontNormal}> */}

                        {/* </p> */}
                        <p className={styles.fontNormal}>
                            Finally, we will access, transfer, disclose, and/or preserve personal data, when we have a good faith belief
                            that doing so is necessary to:
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>6.1 </span>Comply with applicable law or respond to valid legal process and
                            judicial orders.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>6.2 </span>Respond to requests from public or governmental authorities,
                            including for national security or law enforcement purposes.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>6.3 </span> Protect the vital interests of our users, customers, or other
                            third parties.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>6.4 </span>Operate and/or maintain the security or integrity of our products,
                            including to prevent or stop an attack on our computer systems or networks.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>6.5 </span>Protect the rights, interests or property of Niurix or third
                            parties.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>6.6</span> Prevent or investigate possible wrongdoing in connection with the
                            products. <br></br>
                            <br></br>
                            We may use and share aggregated non-personal information with third parties for marketing, advertising, and
                            analytics purposes. We do not sell or trade your information to third parties.
                        </p>
                    </div>
                    <div>
                        <p className={styles.fontBold}>7. How to Access and Control Your personal data?</p>
                        <p className={styles.fontNormal}>
                            You can view, access, edit, or request a copy of your data. You can also delete certain elements of your data or
                            move certain elements of your data to “inactive” status where the data will no longer be processed. You can also
                            make choices about Niurix collection and use of your data.
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>7.1 Data Access - </span>You can access your personal data on your accounts
                            user dashboard.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>7.1.1 Discovery of Personal Information -</span> Data subjects may request
                            confirmation of whether Niurix maintains their personal information by submitting a written request via email to
                            &nbsp;
                            <a className={styles.anchorTag} href="mailto:privacy@niurix.com">
                                privacy@niurix.com
                            </a>{" "}
                            .&nbsp;The request should include sufficient identification. Upon receipt, Niurix will verify the data subject's
                            identity and respond within thirty (30) days, providing access or confirmation as applicable, in accordance with
                            documented procedures for handling such requests.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>7.1.2 Denial of Access - </span>If access is denied (e.g., due to legal,
                            security, or operational reasons), data subjects will be informed in writing of the denial, the specific
                            reason(s), and any available rights to challenge the denial, as permitted or required by applicable law or
                            regulation.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>7.2 Data Portability -</span> You can request a copy of your data by sending
                            an email to us
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>7.3 Data Correction -</span> You can modify your personal data on your
                            accounts user dashboard.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>7.3.1 Review and Correction Procedure - </span>Data subjects may review,
                            update, or correct their personal information by accessing their user dashboard or submitting a written request
                            via email to &nbsp;
                            <a className={styles.anchorTag} href="mailto:privacy@niurix.com">
                                privacy@niurix.com
                            </a>{" "}
                            .&nbsp;Upon verification of identity, Niurix will process corrections within thirty (30) days and communicate
                            any amendments to relevant third parties where committed or required (e.g., service providers or legal
                            obligations), in accordance with documented procedures.
                        </p>

                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>7.3.2 Denial of Correction - </span>If a request for correction is denied,
                            data subjects will be informed in writing of the denial, the specific reason(s), and any available rights to
                            challenge the denial, as permitted or required by applicable law or regulation.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>7.4 Accounting of Personal Information and Disclosures - </span>
                            Upon request, data subjects may obtain an accounting of the personal information held about them, including
                            types of personal and sensitive personal information (e.g., contact details, device data), related processes and
                            systems for handling such information, and disclosures to third parties (e.g., vendors as described in Section
                            6). Requests should be submitted via email to &nbsp;
                            <a className={styles.anchorTag} href="mailto:privacy@niurix.com">
                                privacy@niurix.com
                            </a>{" "}
                            .&nbsp;with sufficient identification.Niurix will verify identity and provide the accounting within 30 days,
                            including details on relevant third-party systems and processes where applicable, in accordance with documented
                            procedures. If a request is denied, data subjects will be informed of the reason(s) and any rights to challenge,
                            consistent with Section 7.1.2.
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontBold}>
                            8. Where Do We Store and Process Personal Data and Conduct International Transfers?
                        </p>
                        <p className={styles.fontNormal}>
                            Personal data collected by Niurix can be stored and processed in the United States where Niurix or its
                            affiliates, subsidiaries or service providers maintain facilities. The storage location is chosen to allow us to
                            operate more efficiently, to improve performance, and to create redundancies to protect the data in the event of
                            an outage or other problem. We take steps to ensure that the data we collect is processed according to the
                            provisions of this Policy, and that we comply with the requirements of applicable law wherever the data is
                            located.
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>8.1 Data Retention: </span>We may retain your information for as long as you
                            continue to use our product, have an account with us, or as necessary to fulfil the purposes outlined in this
                            Policy. You can ask to close your account by contacting us, and we will either delete your information, or move
                            it to “inactive” status where it will no longer be processed. We may, however, retain personal information for
                            an additional period as is permitted or required under applicable laws, for legal, tax, or regulatory reasons,
                            or for any other legitimate and lawful business purpose.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>8.2 Customer data deletion request: </span>
                            Customers may request the deletion of their data by submitting a written request to Niurix via email at &nbsp;
                            <a className={styles.anchorTag} href="mailto:privacy@niurix.com">
                                privacy@niurix.com
                            </a>{" "}
                            .&nbsp; The request should include sufficient identification and a clear reason for deletion. Upon receipt of
                            the request, Niurix will verify the customer's identity and confirm the deletion request within five (5)
                            business days.
                        </p>
                        <p className={styles.fontNormal}>
                            Niurix will then proceed with the deletion of the customer’s data within thirty (30) days of confirmation,
                            unless retention is required by law, regulation, or contract. A confirmation of the data deletion will be
                            provided to the customer once the process is complete.
                        </p>
                        <p className={styles.fontNormal}>
                            <span className={styles.fontBold}>8.3 Changes to our Privacy Policy: </span>
                            We will update this Policy when necessary to reflect customer feedback, as well as to reflect periodic changes
                            in the Niurix website or our product. When we post changes to this Policy, we will revise the “last updated”
                            date at the top of the Policy. If there are material changes to the Policy or in how Niurix uses your data, we
                            will notify you either by prominently posting a notice of such changes before they take effect or by directly
                            sending you a notification. We encourage you to review this Policy periodically to learn how Niurix is
                            protecting your information.
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontBold}>9. How to Contact Us?</p>
                        <p className={styles.fontNormal}>
                            If you have a technical or support question, please send us an email at &nbsp;
                            <span className={styles.fontNormal}>
                                <a className={styles.anchorTag} href="mailto:support@niurix.com">
                                    support@niurix.com
                                </a>
                                .
                            </span>
                        </p>

                        <p className={styles.fontNormal}>
                            If you have any complaints or grievances, please send us an email at &nbsp;
                            <span className={styles.fontNormal}>
                                <a className={styles.anchorTag} href="mailto:grievance@niurix.com">
                                    grievance@niurix.com
                                </a>
                                .
                            </span>
                        </p>
                    </div>

                    <div>
                        <p className={styles.fontNormal}>
                            For any privacy concern, complaint, or a question for the Data Protection Team of Niurix, please contact us by
                            sending us an email at &nbsp;
                            <span className={styles.fontNormal}>
                                <a className={styles.anchorTag} href="mailto:security@niurix.com">
                                    security@niurix.com
                                </a>
                                .
                            </span>
                            &nbsp; We will respond to any queries or concerns within seven (7) days.
                        </p>
                    </div>
                    <div className={`${styles.headerPart} ${styles.updatedDatePart}`}>
                        <span className={`${styles.effectiveDateTxt} ${styles.fontNormal}`}>Last Updated Date : March 05, 2026</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
